// extracted by mini-css-extract-plugin
module.exports = {"inner":"coming-soon-modal_inner__9Iffc","ingress":"coming-soon-modal_ingress__WMwzB","inputs":"coming-soon-modal_inputs__j7_D5"};